<template>
  <div>
    <teleport to="body">
      <transition name="fade" mode="out-in">
        <div v-if="show" class="fixed z-50 top-0 h-full w-full bg-backdrop" @click.self="close" />
      </transition>
    </teleport>

    <teleport to="body">
      <transition name="slide-to-right" mode="out-in">
        <div v-if="show" class="fixed z-50 top-0 left-sidebar h-full max-w-calc-sidebar bg-primary" :style="`width: ${width}px`" @click.stop>
          <ButtonModule
            prefix="icon-close"
            :has-hover="true"
            class="absolute right-14 top-14 text-14 md:text-18 text-dark-600 cursor-pointer"
            @click="close"
          />
          <!-- content -->
          <slot />
        </div>
      </transition>
    </teleport>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'

import ButtonModule from '@/components/shared/form-controls/ButtonModule'

export default defineComponent({
  components: {
    ButtonModule
  },

  props: {
    width: {
      type: Number,
      default: 300
    }
  },

  setup (props, { emit }) {
    const show = ref(false)

    function open () {
      show.value = !show.value
    }

    function close () {
      show.value = false
    }

    return {
      // ref
      // data,
      show,
      // computed
      // function
      close,
      open
    }
  }
})
</script>
